<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">
        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{ 'Asignar evaluación de alumnos a colaborador'}}
                </div>
            </div>
            <div class="modalContenido">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <h5>PASO 1 - Colaboradores a evaluar</h5>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <div *ngFor="let colaborador of listacolaboradores">
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <h5>{{colaborador.nombreypuesto}}</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <h5>PASO 2 - Modalidad de asignación de alumnos</h5>
                        <div class="divisor8"></div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <dropdownCustom
                                    [titulo]="'Tipo de Asignacion'"
                                    [(ngModel)]="tipoasignacionalumnocolaboradorid"
                                    [opciones]="SelTipoAsignacion"
                                    [valorName]="'tipoasignacionalumnocolaboradorid'"
                                    [displayValor]="'nombre'"
                                    [buscar]="false"
                                    (ngModelChange)="Modalidad($event)"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-8 col-md-8 col-sm-12 col-12" *ngIf="tipoasignacionalumnocolaboradorid == 1">
                                <inputCustom
                                    [titulo]="'Cantidad de alumnos por grupo'" [(ngModel)]="numero" [errorActivo]="errorActivo" [mask]="sistemaService.numeroEnteroMask"
                                    ></inputCustom>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngIf="tipoasignacionalumnocolaboradorid == 1">
                                <button class="boton botonSM filled" (click)="asignar()">
                                    Asignar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12" [hidden]="!tipoasignacionalumnocolaboradorid">
                        <h5>PASO 3 - Alumnos asignados</h5>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <dx-tree-view
                                    id="treeview"
                                    [width]="300"
                                    dataStructure="plain"
                                    parentIdExpr="padreid"
                                    keyExpr="id"
                                    displayExpr="nombre"
                                    [searchEnabled]="true"
                                    searchMode="contains"
                                    [showCheckBoxesMode]="'selectAll'"
                                    [selectionMode]="'multiple'"
                                    [selectNodesRecursive]="true"
                                    [createChildren]="createChildren"
                                    hasItemsExpr="isDirectory"
                                    >
                                    <dxo-search-editor-options placeholder="Buscar">
                                    </dxo-search-editor-options>
                                </dx-tree-view>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            Cancelar
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
